import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import immer from 'immer';
import { PureComponent } from '../component';
import Alert from '../Alert';
import { messageClass } from './styles';
import { getUidStr } from '../utils/uid';

var Container =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Container, _PureComponent);

  var _super = _createSuper2(Container);

  function Container(props) {
    var _this;

    _classCallCheck(this, Container);

    _this = _super.call(this, props);
    _this.handleClassName = void 0;
    _this.handleStyle = void 0;
    _this.state = {
      messages: []
    };
    _this.removeMessage = _this.removeMessage.bind(_assertThisInitialized(_this));

    _this.handleClassName = function () {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'top';
      var closeMsg = arguments.length > 1 ? arguments[1] : undefined;
      return messageClass('item', "item-".concat(closeMsg ? 'dismissed' : 'show', "-").concat(position));
    };

    _this.handleStyle = function (closeMsg, h, position) {
      if (!closeMsg || h == null) {
        return null;
      }

      var styles = {}; // if bottom, switch left or right

      switch (position) {
        case 'bottom-right':
        case 'bottom-left':
          break;

        default:
          styles = {
            zIndex: -1,
            opacity: 0,
            marginTop: -h
          };
          break;
      }

      return styles;
    };

    return _this;
  }

  _createClass(Container, [{
    key: "addMessage",
    value: function addMessage(msg) {
      var _this2 = this;

      var id = getUidStr();
      this.setState(immer(function (state) {
        state.messages.push(Object.assign({
          id: id
        }, msg));
      }));

      if (msg.duration > 0) {
        setTimeout(function () {
          _this2.setState(immer(function (state) {
            state.messages.forEach(function (m) {
              if (m.id === id) {
                m.dismiss = true;
              }
            });
          }));
        }, msg.duration * 1000);
      }

      return this.closeMessageForAnimation.bind(this, id, 200, 200);
    }
  }, {
    key: "removeMessage",
    value: function removeMessage(id) {
      var callback;
      var messages = this.state.messages.filter(function (m) {
        if (m.id !== id) return true;

        if (m.onClose) {
          callback = m.onClose;
        }

        return false;
      });

      if (messages.length === 0) {
        this.props.onDestory();
      } else {
        this.setState({
          messages: messages
        });
      }

      if (callback) callback();
    }
  }, {
    key: "closeMessageForAnimation",
    value: function closeMessageForAnimation(id, duration, msgHeight) {
      var _this3 = this;

      if (!duration) {
        this.removeMessage(id);
        return;
      } // duration animation duration time


      this.setState(immer(function (state) {
        state.messages.forEach(function (m) {
          if (m.id === id) {
            m.dismiss = true;
            m.h = (msgHeight || 0) + 20; // messageHeight + messageMargin
          }
        });
      }));
      setTimeout(function () {
        _this3.removeMessage(id);
      }, duration);
    }
  }, {
    key: "closeEvent",
    value: function closeEvent(id, duration) {
      if (duration === 0) {
        return this.removeMessage.bind(this, id);
      }

      return undefined;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var messages = this.state.messages;
      return [messages.map(function (_ref) {
        var id = _ref.id,
            type = _ref.type,
            content = _ref.content,
            dismiss = _ref.dismiss,
            h = _ref.h,
            title = _ref.title,
            top = _ref.top,
            className = _ref.className,
            position = _ref.position,
            hideClose = _ref.hideClose;
        return (
          /*#__PURE__*/
          React.createElement("div", {
            key: id,
            className: "".concat(_this4.handleClassName(position, dismiss), " ").concat(className),
            style: _this4.handleStyle(dismiss, h, position)
          },
          /*#__PURE__*/
          React.createElement(Alert, {
            outAnimation: true,
            className: messageClass('msg'),
            dismiss: dismiss,
            hideClose: hideClose,
            onClose: _this4.closeMessageForAnimation.bind(_this4, id),
            icon: true,
            iconSize: title ? 20 : 14,
            style: {
              top: top
            },
            type: type
          }, title &&
          /*#__PURE__*/
          React.createElement("h3", null, title), content))
        );
      })];
    }
  }]);

  return Container;
}(PureComponent);

Container.displayName = void 0;
Container.displayName = 'ShineoutMessage';
export default Container;